import { render, staticRenderFns } from "./ProfileUploadDocument.vue?vue&type=template&id=6e0d5a2e&scoped=true&"
import script from "./ProfileUploadDocument.vue?vue&type=script&lang=js&"
export * from "./ProfileUploadDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0d5a2e",
  null
  
)

export default component.exports